module.exports = __webpack_public_path__ + "static/media/064-lithuania.f32bce53.svg";